import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Observable} from "rxjs/Observable";
import {NoteEntity} from "./note.entity";
import {NoteActions} from "./note.actions";

@Injectable()
export class NoteService {

  private databaseProvider;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector) {
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  addAll(notes: Array<NoteEntity>, synced: boolean = true): void {
    if (!synced) {
      for (let note of notes) {
        if (!location.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(note)
            .then((note: NoteEntity) => {
              this.store.dispatch(NoteActions.add(note));
            });
        }
      }
    } else {
      this.store.dispatch(NoteActions.addAll(notes));
    }
  }

  add(note: NoteEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.createDocumentWithoutInit(note)
        .then((note: NoteEntity) => {
          this.store.dispatch(NoteActions.add(note));
        });
    } else {
      this.store.dispatch(NoteActions.add(note));
    }
  }

  set(note: NoteEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.updateDocument(note)
        .then((note: NoteEntity) => {
          this.store.dispatch(NoteActions.set(note));
        });
    } else {
      this.store.dispatch(NoteActions.set(note));
    }
  }

  remove(note: NoteEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocument(note)
        .then(() => {
          this.store.dispatch(NoteActions.remove(note._id));
        });
    } else {
      this.store.dispatch(NoteActions.remove(note._id));
    }
  }

  getById(id: string): Observable<NoteEntity> {
    return this.store.select('notes').map((notes: Array<NoteEntity>) => {
      return notes.find((note: NoteEntity) => {
        return note._id === id;
      });
    });
  }

  public getAll(): Observable<Array<NoteEntity>> {
    return this.store.select('notes')
      .map((anmerkungen: Array<any>) => {
        return anmerkungen
          .filter((anmerkung: NoteEntity) => {
            return !anmerkung.hasOwnProperty('_deleted') && !anmerkung.hasOwnProperty('deleted');
          })
          .sort(function(a, b) {
          if(a.category.toLowerCase() === b.category.toLowerCase()){
            return 0;
          }
          else if(!b.category){
            return -1;
          }
          else if(!a.category){
            return 1;
          }
          else {
            return a.category.toLowerCase() < b.category.toLowerCase() ? -1 : 1;
          }
        })
      })
  }

  public getCategories(): Observable<Array<string>> {
    return this.store.select('notes')
      .map((anmerkungen: Array<NoteEntity>) => {
        let categories: Array<string> = [];
        for(let anmerkung of anmerkungen){
          if(categories.indexOf(anmerkung.category) === -1){
            categories.push(anmerkung.category);
          }
        }
        return categories.sort((category1, category2) => {
          if (category1.toLowerCase() < category2.toLowerCase()) {
            return -1;
          }
          if (category1.toLowerCase() > category2.toLowerCase()) {
            return 1;
          }
          // a muss gleich b sein
          return 0;
        });
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/note/note.service.ts